import type { ReactNode } from 'react'
import { cx } from './utils/cx'

// Reference library ships `accent` + `hot`. `ink` is a SnapTransfer
// extension for the inverse (paper-on-ink) treatment used on PricingTable
// feature callouts.
export type StripeTagVariant = 'accent' | 'hot' | 'ink'

export function StripeTag({
  variant,
  side = 'left',
  children
}: {
  variant?: StripeTagVariant
  side?: 'left' | 'right'
  children?: ReactNode
}) {
  return <span className={cx('st-stripe-tag', side === 'right' && 'right', variant)}>{children}</span>
}
